<template>

  <div>
    <v-dialog v-model="show" max-width="700" persistent>
      <v-card max-height="600">
        <v-card-title>Atividades complementares de {{provaName}}</v-card-title>
        <v-divider/>
        <v-card-text >
          <v-file-input v-model="arquivoSelecionado" label="Selecione o arquivo"/>
          <v-row v-for="arquivo in arquivoList" v-bind:key="arquivo.cdArquivo" style="margin-top: 15px;">
            <v-text-field
                prepend-icon="mdi-map-marker"
                :value="arquivo.nomeOriginal"
                disabled
            />
            <v-btn class="mt-4 ml-5" fab dark small color="blue" @click="download(arquivo)">
              <v-icon dark>
                download
              </v-icon>
            </v-btn>
            <v-btn class="mt-4 ml-2" fab dark small color="red" @click="askToDelete(arquivo)">
              <v-icon dark>
                delete
              </v-icon>
            </v-btn>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn v-show="!arquivoId" color="green" dark @click="uploadArquivo" :loading="salvandoArquivo">Salvar</v-btn>
          <v-btn  color="red" dark @click="fechar" :loading="salvandoArquivo">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CONFIRM DIALOG -->
    <v-dialog v-model="confirmDialog" min-width="290" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">{{ mensagem }}</v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn :disabled="confirmando" color="error" text @click="confirmDialog=false">CANCELAR</v-btn>
          <v-btn :loading="confirmando" color="green darken-1" text @click="confirmFunction">ACEITAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- CONFIRM DIALOG -->
  </div>

</template>

<script>

  import ArquivoService from "../../service/ArquivoService"

  export default {
    name: "ProvaPicker",
    props: {
      show:Boolean,
      id:Number,
      arquivoId:Number,
      arquivoName:String,
      downloadFinished:Function,
      confirmarDelete:Function,
      fechar:Function,
      provaName:String,
      arquivoList:Array
    },
    data() {
      return {
        arquivoSelecionado: null,
        salvandoArquivo: false,
        mensagem: "",
        confirmDialog: false,
        confirmando: false,
        confirmFunction: null,
        arquivoToDelete: null
      }
    },
    methods: {
      uploadArquivo() {
        const formData = new FormData();
        formData.append("arquivo", this.arquivoSelecionado);
        let nome = this.arquivoSelecionado.name.replace(/ /g, "") + "_" + new Date().getTime();
        this.salvandoArquivo = true;

        ArquivoService.upload(formData, 'caderno', this.id, nome)
          .then(resp => {
              this.downloadFinished(this.id, resp.data);
          })
          .finally(() => {
            this.salvandoArquivo = false;
            this.arquivoSelecionado = null;
          })
      },

      download(arquivo) {
        ArquivoService.downloadById(arquivo.cdArquivo)
            .then(response => {
              let buffer = this.base64ToArrayBuffer(response.data);
              this.saveByteArray(arquivo.nomeOriginal, buffer, arquivo.contentType);
            })
            .finally(() => {
              this.codigoDoArquivoQueEstaBaixando = 0;
            })
      },

      base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      },

      saveByteArray(reportName, byte, contentType) {
        var blob = new Blob([byte], {type: contentType});
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
      },

      askToDelete(arquivo) {
        this.arquivoToDelete = arquivo;
        this.mensagem = `Deseja deletar o arquivo ${arquivo.nomeOriginal}?`;
        this.confirmDialog = true;
        this.confirmFunction = this.delete;
      },

      delete() {
        this.confirmando = true;
        ArquivoService.delete(this.arquivoToDelete.cdArquivo)
          .then(() => {
            this.confirmarDelete(this.id, this.arquivoToDelete);
          })
          .finally(() => {
            this.confirmDialog = false;
            this.confirmando = false;
          })
      }
    }
  }

</script>